module.exports = __webpack_public_path__ + "static/img/14000093.844e9a96.png";